import {
    call_chatbot_api
} from '../../Slices/commonSlices/Chatbot_slice';
import axiosInstance from 'services/api/axiosInstance';

export const callChatbotApi = params => async (dispatch) => {
    let endpoint_params = {
        language: 'English', 
        ...params
    };

    delete endpoint_params.show_chatbot_widget

    try {
        dispatch(call_chatbot_api({ type: 'call_chatbot_request', data: params }))
        const { data } = await axiosInstance.post('/chat_bot_widget', endpoint_params)

        if (data?.error_code === 200) {
            dispatch(call_chatbot_api({ type: 'call_chatbot_response', data: data?.data }))
        } else {
            dispatch(call_chatbot_api({ type: 'call_chatbot_failure', data: data?.message }))
        }
    }
    catch (Err) {
        dispatch(call_chatbot_api({ type: 'call_chatbot_failure', payload: Err?.message }))
    }
}